<template>
 <div style="font-family: Helvetica; letter-spacing: 1.2px;">

      <Row v-if="orderData" :gutter="10">
        <Col :xs="24" :sm="8" :md="8" :lg="9" >
          <div class="orderInfo">
            <ul>
              <li>
                <label>Order ID</label>
                <span style="color: black; font-size: 22px;"> #{{orderData.orderNumber}}</span>

                        <Icon :class="'card-label mod-card-front card-label-header-'+priorityObj[orderData.priority]" type="md-flag" slot="dot" style="font-size: 18px; margin-right: 50px;" ></Icon>
              </li>
              <li>
                <ul style="display: flex; justify-content: space-between; padding: 0px 90px 0px 0px;">
                  <li style="padding: 0px">
                    <label>Material</label>
                    <span style="color: black; font-size: 14px;">{{orderData.materials?orderData.materials.type:''}}
                    <span v-if="orderData.materials && orderData.materials.originalBoxes && orderData.materials.originalBoxes!==orderData.materials.boxes" style="text-decoration: line-through;color: grey">{{orderData.materials.originalBoxes}}</span>
                    <span v-if="orderData.materials && orderData.materials.boxes" style="margin-left: 8px">{{orderData.materials.boxes}} Box</span>
                    </span>
                  </li>
                  <li style="padding: 0px">
                    <label>Quantity</label>
                    <span v-if="orderData.materials && orderData.materials.originalKg && orderData.materials.originalKg!==orderData.materials.kg" style="text-decoration: line-through;color: grey; font-size: 14px;">{{orderData.materials.originalKg}}</span>
                    <span v-if="orderData.materials && orderData.materials.kg"  style="color: black; font-size: 14px;margin-left: 8px">{{orderData.materials.kg}} Kg</span>
                  </li>
                  <li style="padding: 0px; margin: 0 0 0 10px">
                    <label>Size</label>
                    <span style="font-size: 14px;text-transform: capitalize">{{orderData.orderDetails.materialSize || '-'}}</span>

                  </li>
                </ul>
              </li>
              <li>
                <div class="orderStatus" style="height: 100%;">
                  <ul style="display: flex;" v-if="orderData.orderDetails">

                    <li style="padding: 0px">
                      <Tooltip content="Pickup Confirmation">
                      <i class="fas fa-truck-pickup" :style="orderData.orderDetails.pickupConfirmation=='Done'?'color: #262626':'color: lightgrey'"></i>
                      </Tooltip>
                    </li>
                    <li style="padding: 0px; margin-left: 10px; ">
                      <Tooltip content="Order Readiness">
                        <i class="fas fa-box-check" :style="orderData.orderDetails.orderReadiness.isOrderReady?'color: #262626':'color: lightgrey'"></i>
                      </Tooltip>
                    </li>
                    <li style="padding: 0px; margin-left: 10px; ">
                      <Tooltip content="LR Ready">
                        <i class="fas fa-file-spreadsheet" :style="orderData.orderDetails.lrObject.islrReady?'color: #262626':'color: lightgrey'"></i>
                      </Tooltip>
                    </li>
                    <li style="padding: 0px; margin-left: 10px;" >
                      <Tooltip content="Confirmation Email">
                        <i class="fas fa-envelope" :style="orderData.orderDetails.lrObject.isEmailSent?'color: #262626':'color: lightgrey'"></i>
                      </Tooltip>
                    </li>
                  </ul>
                </div>
              </li>
              <div style="float: right">
                <label>Created On</label>
                <span style="margin: 0 0 0px 5px; font-size: 14px;">{{moment(orderData.createdAt).format('DD MMM \'YY hh:mm A')}}</span>
                <label style="margin: 24px 0 0 0">Updated On</label>
                <span style="margin-left: 5px; font-size: 14px;">{{moment(orderData.updated_at).format('DD MMM \'YY hh:mm A')}}</span>
              </div>
              <li v-if="orderData.orderDetails && orderData.orderDetails.lrObject && orderData.orderDetails.lrObject.lrName">
              <label>LR Name</label>
              <span style="margin-left: 5px; font-size: 14px;">{{orderData.orderDetails.lrObject.lrName}}</span>
                <template v-if="orderData.internalStatus.id!==Constants.internalStatus.inProcessOfDeparture&&
                                orderData.internalStatus.id!==Constants.internalStatus.onTheWayToDropCityWarehouse&&
                                orderData.internalStatus.id!==Constants.internalStatus.atDestinationCityWarehouse&&
                                orderData.internalStatus.id!==Constants.internalStatus.completed&&
                                orderData.internalStatus.id!==Constants.internalStatus.cancel&&
                                orderData.internalStatus.id!==Constants.internalStatus.rejected&&
                                !orderData.orderDetails.loadedInTruck">
                <i class="fas fa-pen edit-lr-icon" @click="onEditLR(orderData.orderDetails.id, orderData.orderDetails.lrObject)"></i>
                </template>
              </li>
              <li>
              <label>Eway Bill No.
                <template v-if="orderData.orderDetails && orderData.orderDetails.ewayBillNo">
                <Tag color="green" v-if="orderData.orderDetails.isEwayBillVerified">Verified</Tag><Tag v-else>Not Verified</Tag>
                </template>
              </label>
              <template v-if="orderData.orderDetails && orderData.orderDetails.ewayBillNo">
              <span style="margin-left: 5px; font-size: 14px;">{{orderData.orderDetails.ewayBillNo}}</span>
                <i class="fas fa-pen edit-lr-icon" @click="onEditEway(orderData)"></i>
              </template>
                <template v-if="orderData.orderDetails && !orderData.orderDetails.ewayBillNo">
                  <i class="fas fa-plus edit-lr-icon" @click="onAddEway(orderData)"></i>
                </template>
              </li>

            </ul>

          </div>
        </Col>
        <Col :xs="24" :sm="8" :md="8" :lg="7" style="text-align: center">
          <template v-if="cancelBtnVisibleIn.includes(orderData.internalStatus.id)">
          <Button type="primary" @click="cancelOrder" ghost style="margin-top: 25px">CANCEL ORDER</Button><br>
          </template>
          <template v-if="splitBtnVisibleIn.includes(orderData.internalStatus.id)">
          <Button type="success" @click="$emit('openSplitDrawer', true)" style="margin-top: 5px">SPLIT ORDER</Button><br>
          </template>
          <template  v-if="orderData && orderData.internalStatus && orderData.internalStatus.id != Constants.internalStatus.pendingForApproval">
          <Button type="primary" @click="openBreakageDialog(orderData.orderDetails.id, orderData.internalStatus.id,
                  orderData.orderDetails.dispactchVerification, orderData.materials, orderData.id)" ghost style="margin-top: 25px">Enter Breakage</Button>
          </template>
            <Button type="primary" @click="openNoteDialog(orderData.id)" ghost style="margin: 25px 0px 0px 24px">Enter Note</Button>
            <br>
          <template  v-if="orderData && orderData.internalStatus && orderData.internalStatus.id != Constants.internalStatus.pendingForApproval">
          <Button type="primary" @click="openBreakageHistory(orderData.id)" ghost style="margin-top: 25px">Breakage History</Button>
          </template>
          <!--<Button type="primary" @click="openNoteHistory(orderData.id)" ghost style="margin: 25px 0px 0px 16px">Note History</Button>-->

        </Col>
        <Col :xs="24" :sm="8" :md="8" :lg="8" >
          <div class="orderLocation">

            <ul>

              <li>
                <ul style="display: flex; justify-content: space-between;">
                  <li>
                    <label>Order Location</label>
                    <span class="location"><i class="fal fa-map-marker-alt" style="font-size: 14px;"></i><span style="margin-left: 5px; font-size: 14px;">{{orderData.clientobject?orderData.clientobject.address[0].city:''}}</span></span>
                  </li>
                  <li>
                    <label>Status</label>
                    <span style="text-transform: capitalize; font-size: 14px; color: green">{{orderData.internalStatus.name}}</span>
                  </li>
                </ul>
              </li>
              <li>
                <div class="destination">
                  <div>
                    <label>Pickup Location</label>
                    <div class="pickup">

                        <p><i class="fal fa-map-marker-alt"></i><span style="margin-left: 10px;">{{orderData.pickuppartyobject?orderData.pickuppartyobject.address[0].city:''}}</span></p>
                        <hr class="new"/>
                        <p><i class="fal fa-calendar-alt" style="margin-right: 10px; margin-top: 4px;"></i><span style="margin-top: 4px;">{{moment(orderData.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}}</span></p>

                    </div>
                  </div>

                  <i class="fal fa-exchange" style="font-size: 24px; margin-top: auto; margin-bottom: auto;"></i>

                  <div>
                    <label>Drop Location</label>
                    <div class="drop">

                        <p><i class="fal fa-map-marker-alt"></i><span style="margin-left: 10px;">{{orderData.droppingpartyobject?orderData.droppingpartyobject.address[0].city:''}}</span></p>
                        <hr class="new"/>
                        <p><i class="fal fa-calendar-alt" style="margin-right: 10px; margin-top: 4px;"></i><span style="margin-top: 4px;">{{moment(orderData.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}}</span></p>

                    </div>
                  </div>

                </div>
              </li>

              <template v-if="orderData&&orderData.orderDetails&&(orderData.orderDetails.PIckupTempo||orderData.orderDetails.PickupTruck||orderData.orderDetails.truckOrder)">
                <li>
                  <label>Local Transport</label>
                  <span v-if="orderData.orderDetails.PIckupTempo" style="margin-left: 5px; font-size: 14px;">{{orderData.orderDetails.PIckupTempo.tempo.platNo}} ↔
                    {{orderData.orderDetails.PIckupTempo.driverDetail.name+' ('+orderData.orderDetails.PIckupTempo.driverDetail.mobile+')'}}</span>
                  <span v-else-if="orderData.orderDetails.PickupTruck" style="margin-left: 5px; font-size: 14px;">{{orderData.orderDetails.PickupTruck.truck.platNo}} ↔
                    {{orderData.orderDetails.PickupTruck.driverDetail.name+' ('+orderData.orderDetails.PickupTruck.driverDetail.mobile+')'}}</span>
                  <span v-else>-</span>
                </li>
                <li>
                  <label>Transport Vehicle</label>
                  <span v-if="orderData.orderDetails.truckOrder" style="margin-left: 5px; font-size: 14px;">{{orderData.orderDetails.truckOrder.truck.platNo}} ↔
                    {{orderData.orderDetails.truckOrder.driverDetail.name+' ('+orderData.orderDetails.truckOrder.driverDetail.mobile+')'}}</span>
                  <span v-else>-</span>
                </li>
              </template>


            </ul>

          </div>
        </Col>
      </Row>

   <Modal v-model="breakageHistoryDialog" :mask-closable="false" width="550" scrollable draggable>
     <div slot="header"><strong>Breakage History</strong></div>
     <div style="max-height: 400px;overflow: hidden;overflow-y: scroll;">
       <Timeline>
         <TimelineItem v-for="(breakage, index) in breakageArr" :key="index">
           <p class="time"><b>{{mapInternalStatus[breakage.internalStatusId]}}</b>
             <p style="margin-top: -2px;font-size: 12px;margin-bottom: 6px;margin-left: 5px;color: gray;">{{breakage.createdAt}}
                  <span v-if="breakage.createdBy">by {{mappedUsers[breakage.createdBy].name}}</span>
           </p></p>
           <p class="content">
             Final Weight: {{breakage.finalWeight}}<br>
             Final Quantity: {{breakage.finalQuantity}}<br>
             Breakage Quantity: {{breakage.breakageQuantity}}<br>
             Breakage Note: {{breakage.breakageNote}}<br>
             Internal Status: {{mapInternalStatus[breakage.internalStatusId]}}<br>
             Missing Note: {{breakage.missingNote || ''}}
           </p>
         </TimelineItem>
       </Timeline>
       <template v-if="!breakageArr.length">No History Available.</template>
     </div>
   </Modal>
   <Modal v-model="noteHistoryDialog" :mask-closable="false" width="550" scrollable draggable>
     <div slot="header"><strong>Note History</strong></div>
     <div style="max-height: 400px;overflow: hidden;overflow-y: scroll;">
       <Timeline>
         <TimelineItem v-for="(note, index) in notesArr" :key="index">
           <p class="time">
             <p style="margin-top: -2px;font-size: 12px;margin-bottom: 6px;margin-left: 5px;color: gray;">{{moment(note.createdOn).format('DD/MM/YY hh:mm:ss A')}}</p></p>
           <p class="content">
             <u>Created By:</u> {{note.CreatedBy.name}}<br>
             <u>Note:</u> {{note.note}}<br>
           </p>
         </TimelineItem>
       </Timeline>
       <template v-if="!notesArr.length">No History Available.</template>
     </div>
   </Modal>
   <Modal v-model="ewayDialog" :mask-closable="false" width="450" draggable>
     <div slot="header"><strong>Enter Eway Details</strong></div>
     <div>
       <span style="font-size: 15px">Order Number: #{{ewayForm.order?ewayForm.order.orderNumber:''}}</span>
       <Form :model="ewayForm" :rules="ruleEwayForm" ref="ewayForm" :label-width="140">
         <FormItem prop="ewayBillNo" label="Eway Bill No." style="margin: 8px 0px 20px -27px">
           <Input v-model="ewayForm.ewayBillNo"/>
         </FormItem>
         <FormItem label="Eway Bill Verified">
           <i-switch v-model="ewayForm.isEwayBillVerified" size="large">
             <span slot="open">ON</span><span slot="close">OFF</span>
           </i-switch>
         </FormItem>
       </Form>
     </div>
     <div slot="footer">
       <Button type="primary" style="font-weight: bolder" @click="addEwayBillDetails" :loading="loading">
         <span v-if="!loading">SAVE</span>
         <span v-else>Loading...</span>
       </Button>
       <Button style="background: #999999; color: white;font-weight: bolder" @click="ewayDialog=false">CANCEL</Button>
     </div>
   </Modal>
   <cancel-order-popup :formDialog.sync="cancelOrderDialog" :order="orderData" @closeMainModal="closeDrawer"/>

 </div>
</template>

<script>
import moment from 'moment'
import {Constants} from '../../Constants/Constant'
import {mapInternalStatus} from "../ExcelFormattedOrders/Settings";
import {GET_BREAKAGE_HISTORY} from '../../graphql/queries/OrderDetails'
import {GET_ORDER_NOTE_HISTORY} from '../../graphql/queries/Orders'
import {UPDATE_ORDER_BY_STATUS, UPDATE_ORDER_BY_MATERIALS, ADD_ORDER_NOTE} from '../../graphql/mutations/orders'
import {DISPATCH_VERIFICATION, ENTER_EWAY_BILL} from '../../graphql/mutations/ToDoOrders'
import {SEND_PICKUP_EMAIL} from '../../graphql/mutations/ToDoOrders'
import ValidationRules from '../../Constants/ValidationRules'
import CancelOrderPopup from "../ExcelFormattedOrders/CancelOrderPopup";
let splitBtnVisibleIn = [Constants.internalStatus.pendingForApproval,Constants.internalStatus.pendingForOrderConfirmation,
                         Constants.internalStatus.orderNotReady,Constants.internalStatus.underPickupProcess,Constants.internalStatus.readyForPickup,
                         Constants.internalStatus.tempoOnTheWayToPickupLoad,Constants.internalStatus.tempoWaitingForLoadingMaterial]
    export default {
        name: "MOHeader",
      components: {CancelOrderPopup},
      inject: ["setManageOrderDrawer"],
        data: function(){
            return{
                moment: moment,
                Constants: Constants,
                splitBtnVisibleIn: splitBtnVisibleIn,
                cancelBtnVisibleIn: [...splitBtnVisibleIn, Constants.internalStatus.underBillingProcess],
                mutation_UPDATE_ORDER_BY_STATUS: UPDATE_ORDER_BY_STATUS,
                mutation_UPDATE_ORDER_BY_MATERIALS: UPDATE_ORDER_BY_MATERIALS,
                mutation_DISPATCH_VERIFICATION: DISPATCH_VERIFICATION,
                query_BREAKAGE_HISTORY: GET_BREAKAGE_HISTORY,
                orderData: '',
                priorityObj: {0: 'Low', 1: 'Normal', 2: 'High'},
                dispatch_finalQty: '',
                dispatch_finalWt: 0,
                dispatch_breakageQty: 0,
                dispatch_breakageNote: 0,
                dispatch_missingQty: 0,
                dispatch_missingNote: 0,
                breakageHistoryDialog: false,
                breakageArr: [],
                orderNote: '',
                noteHistoryDialog: false,
                notesArr: [],
                /* --------- Eway Bill variables ------------------ */
                loading: false,
                ewayDialog: false,
                ewayForm: { ewayBillNo:'', isEwayBillVerified:false, order: null },
                ruleEwayForm: { ewayBillNo: ValidationRules.textField('Eway Bill No.'), },
                /* -------x---------x--------x-------------x---- */
                cancelOrderDialog: false,
                mapInternalStatus,
                mappedUsers: {}
            }
        },
        methods:{
            async cancelOrder(){
                /*let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_ORDER_BY_STATUS,
                    variables: {
                        orderId: id,
                        internalstatus: '24e00980-9a93-496c-b422-7b17a9ddfc2a',  //Change internalStatusId to Cancel
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                    this.setManageOrderDrawer(false)
                }*/
              this.cancelOrderDialog = true
            },
            closeDrawer(){
              this.setManageOrderDrawer(false)
            },
            onAddEway(order){
                this.$refs['ewayForm'].resetFields()
                this.ewayForm.order = order
                this.ewayForm.isEwayBillVerified = false
                this.ewayDialog = true
            },
            onEditEway(order){
                this.ewayForm.order = order
                this.ewayForm.isEwayBillVerified = order.orderDetails.isEwayBillVerified
                this.ewayForm.ewayBillNo = order.orderDetails.ewayBillNo
                this.ewayDialog = true
            },
            addEwayBillDetails(){
                this.loading = true;
                this.$refs['ewayForm'].validate((valid) => {
                    if (valid) {
                        this.insertEwayBillDetails();
                    }else{
                        this.loading = false
                    }
                })
            },
            async insertEwayBillDetails(){
                let response = await this.$apollo.mutate({
                    mutation: ENTER_EWAY_BILL,
                    variables: {
                        orderDetailId: this.ewayForm.order.orderDetails.id,
                        ewayBillNo: this.ewayForm.ewayBillNo,
                        isEwayBillVerified: this.ewayForm.isEwayBillVerified
                    }
                })
                if(response.data){
                    this.$Message.success('Eway bill details added successfully!')
                    this.$refs['ewayForm'].resetFields()
                    this.loading = false;
                    this.ewayDialog = false;
                }
            },
            openBreakageDialog(orderDetailId, internalStatusId, dispactchVerification, materials, orderId){
                this.dispatch_finalQty = '';
                this.dispatch_finalWt = 0;
                this.dispatch_breakageQty = 0;
                this.dispatch_breakageNote = '';
                this.dispatch_missingQty = 0;
                this.dispatch_missingNote = '';
                this.$Modal.confirm({
                    title: 'Enter Dispatch Details',
                    render: (h) => {
                        return h('div',{style:{paddingBottom:'16px'}}, [[h('p','Final Qty:'),h('Input',{
                            style: {
                                width: '70%',
                                marginBottom: '8px',
                                marginTop: '-25px',
                                float: 'right'
                            },
                            props: {
                                value: this.dispatch_finalQty,
                                autofocus: true,
                                placeholder: 'Final Quantity',

                            },
                            on: {
                                input: (val) => {
                                    this.dispatch_finalQty = val;
                                }
                            }
                        })],
                            [h('p',{style:{marginTop:'16px'}, domProps:{innerHTML:'Final Wt:'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '8px',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_finalWt,
                                    placeholder: 'Enter Final Weight'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_finalWt = val;
                                    }
                                }
                            })],
                            [h('p',{style:{marginTop:'16px'}, domProps:{innerHTML:'Breakage Qty'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '8px',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_breakageQty,
                                    placeholder: 'Breakage Qty'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_breakageQty = val;
                                    }
                                }
                            })],
                            [h('p',{style:{marginTop:'16px'}, domProps:{innerHTML:'Breakage Note'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '32px',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_breakageNote,
                                    placeholder: 'Breakage Note',
                                    type: 'textarea'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_breakageNote = val;
                                    }
                                }
                            })],
                            [h('p',{style:{marginTop:'40px'}, domProps:{innerHTML:'Missing Qty:'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '8px',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_missingQty,
                                    placeholder: 'Missing Qty'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_missingQty = val;
                                    }
                                }
                            })],
                            [h('p',{style:{marginTop:'16px'}, domProps:{innerHTML:'Missing Note:'}}), h('Input', {
                                style: {
                                    width: '70%',
                                    marginBottom: '8px',
                                    minHeight: '8px !important',
                                    height: '8px !important',
                                    marginTop: '-25px',
                                    float: 'right'
                                },
                                props: {
                                    value: this.dispatch_missingNote,
                                    placeholder: 'Missing Note',
                                    type: 'textarea'
                                },
                                on: {
                                    input: (val) => {
                                        this.dispatch_missingNote = val;
                                    }
                                }
                            })]
                        ])
                    },
                    onOk: () => {
                      /* --------- Not to add breakage details if all fields left empty ---------- */
                        if(!this.dispatch_finalQty&&!parseInt(this.dispatch_finalWt)&&!parseInt(this.dispatch_breakageQty)&&
                           !this.dispatch_breakageNote&&!parseInt(this.dispatch_missingQty)&&!this.dispatch_missingNote) return
                      /* -----------x---------------x-----------------x---------------x----------- */
                        this.insertBreakageDetails(orderDetailId, internalStatusId, dispactchVerification)
                        if(this.dispatch_finalQty||this.dispatch_finalWt){this.updateOrder(materials, orderId)}
                    }
                })
            },
            async insertBreakageDetails(orderDetailId, internalStatusId, dispactchVerification){
                console.log('passed insertBreakageDetails')
                let dv = []
                if(dispactchVerification && Object.prototype.toString.call(dispactchVerification) == '[object Array]'){
                    dv = dispactchVerification;
                }
                dv.unshift({
                    createdAt : moment().format('DD-MM-YYYY hh:mm:ss a'),
                    createdBy: JSON.parse(localStorage.tatkalorri).userObj.user.id,
                    internalStatusId: internalStatusId,
                    finalQuantity: this.dispatch_finalQty,
                    finalWeight: this.dispatch_finalWt,
                    breakageQuantity: this.dispatch_breakageQty,
                    breakageNote: this.dispatch_breakageNote,
                    missingQuantity: this.dispatch_missingQty,
                    missingNote: this.dispatch_missingNote,
                })
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_DISPATCH_VERIFICATION,
                    variables: {
                        orderDetailId: orderDetailId,
                        dispactchVerification: dv,
                    }
                })
                if(response.data){
                    this.$Message.success('Breakage details saved successfully!');
                }
            },
            async updateOrder(materials, orderId){
                if(this.dispatch_finalQty){materials.boxes = this.dispatch_finalQty}
                if(this.dispatch_finalWt){materials.kg = this.dispatch_finalWt}
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_ORDER_BY_MATERIALS,
                    variables: {
                        orderId: orderId,
                        materials: materials,
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                }
            },
            async openBreakageHistory(orderDetailId){
                this.mappedUsers = this.$store.state.mappedUsers
                let queryResponse = await this.$apollo.query({
                    query: this.query_BREAKAGE_HISTORY,
                    variables: {orderId: orderDetailId},
                    fetchPolicy: "network-only"
                })
                this.breakageArr = []
                if(queryResponse.data.orderDetails[0].dispactchVerification &&
                    Object.prototype.toString.call(queryResponse.data.orderDetails[0].dispactchVerification) == '[object Array]'){
                    this.breakageArr = queryResponse.data.orderDetails[0].dispactchVerification
                }
                this.breakageHistoryDialog = true
            },
            onEditLR(orderDetailId, lrObject){
                this.lrName = lrObject.lrName;
                this.$Modal.confirm({
                    title: 'Update LR',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.lrName,
                                autofocus: true,
                                placeholder: 'Please enter LR Name'
                            },
                            on: {
                                input: (val) => {
                                    this.lrName = val;
                                }
                            }
                        })
                    },
                    onOk: () => {
                        this.updateLR(orderDetailId, lrObject, this.lrName)
                    }
                })
            },
            async updateLR(orderDetailId, lrObject, lrName){
                let response = await this.$apollo.mutate({
                    mutation: SEND_PICKUP_EMAIL,
                    variables: {
                        orderDetailId: orderDetailId,
                        lrObject: {
                            islrReady: lrObject.islrReady,
                            isEmailSent: lrObject.isEmailSent,
                            lrName: lrName
                        },
                    }
                })
                if(response.data){
                    this.$Message.success('LR updated successfully!');
                }
            },
            openNoteDialog(orderId){
                this.orderNote = ''
                this.$Modal.confirm({
                    title: 'Enter Order Note',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.orderNote,
                                autofocus: true,
                                placeholder: 'Enter Note...',
                                type: 'textarea'
                            },
                            on: {
                                input: (val) => {
                                    this.orderNote = val;
                                }
                            }
                        })
                    },
                    onOk: () => {
                        if(this.orderNote){
                            this.insertOrderNote(orderId)
                        }
                    }
                })
            },
            async insertOrderNote(orderId){
                let response = await this.$apollo.mutate({
                    mutation: ADD_ORDER_NOTE,
                    variables: {
                        orderId: orderId,
                        note: this.orderNote,
                        type: 'NORMAL',
                        createdBy: JSON.parse(localStorage.getItem('tatkalorri')).userObj.user.id,
                        lastUpdatedBy: JSON.parse(localStorage.getItem('tatkalorri')).userObj.user.id,
                        createdOn: moment().format(),
                        updatedOn: moment().format()
                    }
                })
                if(response.data){
                    this.$Message.success('Order Note added successfully!');
                }
            },
           async openNoteHistory(orderId){
                this.notesArr = []
                let response = await this.$apollo.query({
                    query: GET_ORDER_NOTE_HISTORY,
                    variables: {orderId: orderId},
                    fetchPolicy: "network-only"
                })
                if(response.data && response.data.notes.length){
                    this.notesArr = response.data.notes
                }
                this.noteHistoryDialog = true
            }

        }
    }

</script>

<style scoped>
  .orderInfo{
    text-align: left;
  }
  .row{
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex !important;
    overflow: hidden;
  }
  .row .col-4{
    flex: 1 !important;
  }

  p{
    font-size: 14px;
    font-weight: 400;
  }
  .pickup , .drop{
    border: 1px solid #cdcdcd;
    width: 100%;
    padding: 5px;
    border-radius: 5px;
  }
  .pickup p, .drop p{
    color: #8e8e8e;
  }

  .destination{
    display: flex;
    justify-content: space-between;
    text-align: left;
  }

  hr.new {
    border: none;
    border-top: 1px solid #cdcdcd;
  }
  .location{
    text-align: center;
    transition: 0.3s;
    cursor: pointer;
  }
  .location:hover{
    color: #2d8cf0;
  }
  .orderInfo label, .orderLocation label{
    font-size: 12px;
    display: block;
    color: #7d7d7d;
    margin-bottom: 2px;
  }
  ul{
    list-style: none;
  }
  ul li{
    padding: 6px;
  }

.edit-lr-icon{
  font-size: 12px;
  margin-left: 8px;
  cursor: pointer;
}
</style>
